import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '@app/shared/components/input/input.component';
import ValidationResult from '@infrastructure/validation-result';
import { DiscountModel } from '@models/discounts/discount-model';
import { UserDataModel } from '@models/user-data-model';
import { UserService } from '@services/user.service';
import { ButtonComponent } from '../button/button.component';
import { InputAddonComponent } from '../input-addon/input-addon.component';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'customizer-discounts',
    templateUrl: './customizer-discounts.component.html',
    styleUrls: ['./customizer-discounts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ButtonComponent, InputComponent, InputAddonComponent]
})
export class CustomizerDiscountsComponent implements OnChanges {
	@Input() discount: DiscountModel | null;
	@Input() elemClass: Array<string>;
	@Input() widths: Array<string>;
	@Input() discountErrors: ValidationResult;
	@Input() discountsList: Array<DiscountModel> = [];

	@Output() discountChange = new EventEmitter<DiscountModel | null>();
	@ViewChild('discountPercentage') percentageRef: InputComponent;

	public percentage: number | null;
	public user: UserDataModel | null;

	constructor(public userService: UserService) { }

	ngOnChanges(changes: SimpleChanges): void {
		this.percentage = this.discount?.percentage ?? null;
		this.user = this.userService.currentUser$.getValue();
	}

	public setPercentage(percentage: string) {
		const parsedNumber = percentage.length ? parseInt(percentage, 10) : null;
		this.percentage = parsedNumber;
		if (this.discount !== null)
			this.discount.percentage = parsedNumber;
		this.discountChange.emit(this.discount);
	}

	public setDiscount(discount: DiscountModel) {
		if (!discount || (this.discount && this.discount.key === discount.key)) {
			this.percentage = null;
			this.discountChange.emit(null);
		} else {
			discount.percentage = this.percentage;
			this.discountChange.emit(discount);
			this.percentageRef.setFocus();
		}
	}
}
